"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cerro-al-lambro": {
    "fff50e43": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "skipSearch": false
    }],
    "abbazia": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f06c8b1b": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "skipSearch": false
    }],
    "belvedere": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7ac15c16": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "skipSearch": false
    }],
    "colombirolo": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e4013fe": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "skipSearch": false
    }],
    "fornace-di-cerro-al-lambro": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "51b0544e": [{
      "hkey": "af960b7d",
      "slug": "fornaci",
      "name": "Fornaci",
      "primary": true,
      "skipSearch": false
    }],
    "fornaci-di-riozzo": [{
      "hkey": "af960b7d",
      "slug": "fornaci",
      "name": "Fornaci",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2562abd1": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "skipSearch": false
    }],
    "lassi": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9cecc0ba": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "skipSearch": false
    }],
    "volpere": [{
      "hkey": "ea72852b",
      "slug": "cerro-al-lambro",
      "name": "Cerro al Lambro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;